import { Flex, FooterLink, Grid } from "@sidelinesports/fan-design-system";
import { useQuery } from "@tanstack/react-query";
import { getAppConfig } from "../api";
import styles from "./AppFooter.module.css";

export const AppFooter = ({
  showDisclaimer = false,
}: {
  showDisclaimer?: boolean;
}) => {
  const configQuery = useQuery({
    queryKey: ["config"],
    queryFn: () => getAppConfig(),
  });

  if (configQuery.isPending) {
    return null;
  }

  if (configQuery.isError) {
    return null;
  }

  const config = configQuery.data;
  const disclaimer = config.theme.disclaimer;

  return (
    <Grid as="footer" gap="1rem" alignItems="center" justifyContent="center">
      {showDisclaimer && disclaimer && (
        <p className={styles.disclaimer}>{disclaimer}</p>
      )}
      {config.theme.footers.length > 0 && (
        <Flex gap="0.5rem" align="center" justify="center">
          {config.theme.footers.map((footer) => (
            <FooterLink as="a" key={footer.order} href={footer.hyperlink}>
              {footer.text}
            </FooterLink>
          ))}
        </Flex>
      )}
    </Grid>
  );
};
